const STORAGE_KEY = "epayment.payment-session";
let memoryToken = "";

export const clearAccessToken = () => {
  memoryToken = "";
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    /* Storage may be unavailable; keep the token only in memory. */
  }
};

export const setAccessToken = (token) => {
  if (
    typeof token !== "string" ||
    token.length > 8192 ||
    !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token)
  ) {
    clearAccessToken();
    throw new Error("Invalid payment session");
  }
  memoryToken = token;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, token);
  } catch (_) {
    /* Storage may be unavailable; keep the token only in memory. */
  }
};

export const getAccessToken = () => {
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  if (fragment.has("payment_session")) {
    const token = fragment.get("payment_session");
    fragment.delete("payment_session");
    const rest = fragment.toString();
    window.history.replaceState(
      window.history.state,
      "",
      `${window.location.pathname}${window.location.search}${
        rest ? `#${rest}` : ""
      }`,
    );
    try {
      setAccessToken(token);
    } catch (_) {
      return "";
    }
  }
  if (!memoryToken) {
    try {
      const stored = window.sessionStorage.getItem(STORAGE_KEY);
      if (stored) setAccessToken(stored);
    } catch (_) {
      /* Storage may be unavailable; keep the token only in memory. */
    }
  }
  return memoryToken;
};

export const withBrowserAuth = (options = {}) => {
  const token = getAccessToken();
  if (!token) {
    const error = new Error(
      "A valid payment session is required. Open a fresh payment link from the issuing application.",
    );
    error.code = "PAYMENT_SESSION_REQUIRED";
    throw error;
  }
  return {
    ...options,
    headers: { ...options.headers, Authorization: `Bearer ${token}` },
  };
};
